<template lang="pug"> 
//- quillEditorCom(class='ql-editor-box' :fathertext.sync="tanchuadd.content",:styles="''", ,editref="quillEditoradd")
div
    quillEditor( :ref="editref", class="ql-editor" :disabled="readonly", v-model='text', :options='editorOption',@change="onEditorChange" :style='styles')
    input(:class="editref+'File'" , :title="editref", type='file', @change='upimg' , style="display: none;")

</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { uploadPartyPhoto } from "@/api/http";
export default {
  name: "quillCom",
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    editref: {
      type: String,
      default: "myQuillEditor"
    },
    fahertext: {
      type: String,
      default: ""
    },
    fathertext: {
      type: String,
      default: ""
    },
    styles: {
      type: String,
      // default: "height:250px;"
    },
    styleProp: {
      type: Object,
      default() {
        return {
          // width: "250px",
          // height: "250px",
          // marginBottom: "10px"
        };
      }
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      editorOption: {
        placeholder: "暂无信息",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [
                {
                  header: 1
                },
                {
                  header: 2
                }
              ], // custom button values
              [
                {
                  list: "ordered"
                },
                {
                  list: "bullet"
                }
              ],
              [
                {
                  script: "sub"
                },
                {
                  script: "super"
                }
              ], // superscript/subscript
              [
                {
                  indent: "-1"
                },
                {
                  indent: "+1"
                }
              ], // outdent/indent
              [
                {
                  direction: "rtl"
                }
              ], // text direction

              [
                {
                  size: ["small", false, "large", "huge"]
                }
              ], // custom dropdown
              [
                {
                  header: [1, 2, 3, 4, 5, 6, false]
                }
              ],

              [
                {
                  color: []
                },
                {
                  background: []
                }
              ], // dropdown with defaults from theme
              [
                {
                  font: []
                }
              ],
              [
                {
                  align: []
                }
              ],
              // ["image"],
              ["clean"] // remove formatting button
            ], // 工具栏
            handlers: {
              image: value => {
                if (value) {
                  document.querySelector(`.${this.editref}File`).click();
                } else {
                  this.quill.format("image", false);
                }
              }
              //   upload: value => {
              //     if (value) {
              //       alert("自定义文件上传");
              //     }
              //   }
            }
          }
        }
      },
      text: ""
    };
  },
  computed: {
    editRef() {
      return this.editref;
    }
  },
  methods: {
    //上传图片
    async upimg(e) { 
      // 获取富文本组件实例
      let quill = this.$refs[this.editRef].quill;
 
      if (e.target.files[0] == undefined) {
        return false;
      } else {
        // response为图片服务器返回的数据
        try {
          let res = await uploadPartyPhoto(e.target.files[0]);

          // 如果上传成功
          if (res.code === 200) {
            // 获取光标所在位置
            let length = quill.getSelection().index;
            quill.insertEmbed(length, "image", res.content);

            // 调整光标到最后
            quill.setSelection(length + 1);
          } else {
            this.$message.error("图片插入失败");
          }
          e.target.value = "";
        } catch (e) {
          console.log(e);
          this.$message.error("图片插入失败");
        }
      }
    },
    onEditorChange(val) {
      this.$emit("update:fathertext", val.html);
      this.$emit("update:fahertext", val.html);
    }
  },
  created() {
    this.text = this.fahertext || this.fathertext;
    // this.editRef = this.editref;
  },
  mounted(){
      this.$Bus.$on('reset',(data)=>{
          this.text = data
          this.$forceUpdate()
      })
  },
  watch: {
    fahertext(val) {
      this.text = val;
    }
  }
};
</script>
<style lang="less">
.ql-editor-box {
  > .ql-editor {
    // height: 400px;
    // overflow: hidden;
    padding: 0 !important;
  }

  .ql-container {
    // height: 300px;
    // overflow: auto;
  }
}
</style>